export default [
    {
      path: '/bargaining',
      component: () => import('@views/bargaining'),
      children: (pre => [
        {
          path: pre+'/lead-index',
          component: () => import('@views/bargaining/leadIndex'),
          name: 'leadIndex',
          meta: {
            isLogin: false,
            isFooterShow: false,
            title : '砍一刀'
          }
        },
        {
          path: pre+'/rabbit-index',
          component: () => import('@views/bargaining/rabbitIndex'),
          name: 'rabbitIndex',
          meta: {
            isLogin: false,
            isFooterShow: false,
            title : '帮忙砍一刀'
          }
        }
      ])('/bargaining')
    }
  ]
  